import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { AdminLayoutService } from '../../layouts/admin-layout/admin-layout.service';
declare var $: any;

@Component({
  selector: 'app-happy-traveler',
  templateUrl: './happy-traveler.component.html',
  styleUrls: ['./happy-traveler.component.css']
})
export class HappyTravelerComponent implements OnInit, AfterViewInit {
  feedbackId: any = '';
  tripFeedbacklist: any = [];
  selectedTripFeedback: any = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public adminLayoutService: AdminLayoutService,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['Id']) {
        this.feedbackId = params['Id'];
        this.getTripFeedbacks();
        this.getTripFeedbackById();
      } else {
        this.router.navigate(['home']);
      }
    });
  }

  ngAfterViewInit(): void {
    this.initPopularPilgrimsSlick();
  }

  initPopularPilgrimsSlick(): void {
    if ($('.viewdetailsslider').hasClass('slick-initialized')) {
      $('.viewdetailsslider').slick('unslick');
    }
    if ($('.travellers_details_slide').hasClass('slick-initialized')) {
      $('.travellers_details_slide').slick('unslick');
    }

    $('.viewdetailsslider').slick({
      prevArrow: $('.viewmore-prev'),
      nextArrow: $('.viewmore-next'),
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      centerPadding: '20px',
      autoplay: true,
      cssEase: "linear",
      pushOnHover: true,
      autoplaySpeed: 2000,
      loop: true,

      responsive: [{
        breakpoint: 1620,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 578,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });
    $('.travellers_details_slide').slick({
      prevArrow: $('.tr_d_prev'),
      nextArrow: $('.tr_d_next'),
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      centerPadding: '20px',
      autoplay: true,
      cssEase: "linear",
      pushOnHover: true,
      autoplaySpeed: 2000,
      loop: true,

    });
  }

  processImagePaths(basePath: string, imagePaths: any): string[] {
    if (!imagePaths) {
      return [];
    }

    const paths = imagePaths.map(path =>
      `${basePath.replace(/\/$/, '')}/${path.trim().replace(/\\/g, '/')}`
    );

    return paths;
  }

  getTripFeedbacks() {
    this.adminLayoutService.getAllTripFeedbackList().subscribe((Response: any) => {

      if (Response.code == 1) {
        this.tripFeedbacklist = Response.data;
        setTimeout(() => {
          this.initPopularPilgrimsSlick();
        }, 100);
      }
      else {
        this.router.navigate(['home']);
      }
    }, (error) => {
      // console.log(error.error.Message);
      this.router.navigate(['home']);
    });
  }

  getTripFeedbackById() {
    this.selectedTripFeedback = [];
    this.adminLayoutService.GetTripFeedbackById({ id: this.feedbackId }).subscribe((Response: any) => {

      if (Response.code == 1) {
        this.selectedTripFeedback = Response.data;
        this.selectedTripFeedback.image = this.processImagePaths(this.commonService.rootData.rootFilePath, this.selectedTripFeedback.image);
        setTimeout(() => {
          this.initPopularPilgrimsSlick();
        }, 100);
      }
      else {
        this.router.navigate(['home']);
      }
    }, (error) => {
      // console.log(error.error.Message);
      this.router.navigate(['home']);
    });
  }

  redirectToHappyTraveler(feedbackId: any) {
    if ($('.viewdetailsslider').hasClass('slick-initialized')) {
      $('.viewdetailsslider').slick('unslick');
    }
    if ($('.travellers_details_slide').hasClass('slick-initialized')) {
      $('.travellers_details_slide').slick('unslick');
    }
    if (this.feedbackId === feedbackId) {
      this.forceReloadData();
    } else {
      this.selectedTripFeedback = [];
      this.tripFeedbacklist = [];
      this.router.navigate([], {
        queryParams: { Id: feedbackId },
        queryParamsHandling: 'merge',
      });
    }
  }
  forceReloadData() {
    this.selectedTripFeedback = [];
    this.tripFeedbacklist = [];
    this.getTripFeedbacks();
    this.getTripFeedbackById();
  }
}
